var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style["m-banner"] }, [
    _c(
      "div",
      { staticClass: "m-container", class: _vm.$style["m-container"] },
      [
        _c("div", { class: _vm.$style["container-inner"] }, [
          _c(
            "div",
            {
              staticClass: "flex justify-center",
              class: _vm.$style["module-head"]
            },
            [
              _c("div", { class: _vm.$style["module-info"] }, [
                _c(
                  "h2",
                  { ref: "titleText", class: _vm.$style["module-title"] },
                  [
                    _c("div", { class: _vm.$style["line-1"] }, [
                      _c("span", { class: _vm.$style["text"] }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("400000")) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("i", { class: _vm.$style["cursor"] })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h3",
                  { ref: "subtitle", class: _vm.$style["module-subtitle"] },
                  [
                    _c("span", { staticClass: "text" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("400001")) +
                          "\n                        "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "btnGroup",
                    staticClass: "flex justify-center",
                    class: _vm.$style["module-btn-group"]
                  },
                  [
                    !_vm.token
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "grid grid-flow-col-dense justify-center items-center",
                            class: _vm.$style["btn--register"],
                            on: {
                              click: function($event) {
                                return _vm.$router.push({ path: "/register" })
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "text" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("300252")) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("UeIcon", {
                              class: [
                                _vm.$style["ic"],
                                { mirrorRotateLevel: _vm.isDirection }
                              ],
                              attrs: { name: "long-arrow-right" }
                            })
                          ],
                          1
                        )
                      : _c(
                          "button",
                          {
                            staticClass:
                              "grid grid-flow-col-dense justify-center items-center",
                            class: _vm.$style["btn--register"],
                            on: {
                              click: function($event) {
                                return _vm.$router.push({ path: "/download" })
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "text" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("300345")) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("UeIcon", {
                              class: [
                                _vm.$style["ic"],
                                { mirrorRotateLevel: _vm.isDirection }
                              ],
                              attrs: { name: "long-arrow-right" }
                            })
                          ],
                          1
                        )
                  ]
                )
              ])
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7da2823f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da2823f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/index/BannerModule.vue
// module id = KsjU
// module chunks = 0